import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html',
  styleUrls: ['./agreement.component.css']
})
export class AgreementComponent implements OnInit {

  userTerms = [];
  businessTerms = [];
  userCheckmarks = {};
  businessCheckmarks = {};
  temsCheckstats = [];
  token: string;
  tabvis = 0;
  action: string;

  selectedIndex_user = 0;
  selectedIndex_business = 0;
  constructor(
    private _api: ApiService
    , private router: Router
    , private cookie: CookieService
    , private spinner: NgxSpinnerService
    , private route: ActivatedRoute
    , private _utilityService: UtilitiesService
  ) {
    // this.token = cookie.get('token');
    // cookie.deleteAll('/');
  }

  ngOnInit() {
    this.getTerms();
    this.getActionByUrl();
  }
  getActionByUrl() {
    this.route.queryParamMap.subscribe(paramsdata => {
      const action = paramsdata['params']['action'];

      if (action) {
        this.action = action;
        switch (action) {
          case 'passwordReset':
            break;
          default:
            break;
        }
      }
    });
  }
  bindCheckBox(arrayName: string, checkBoxName: string) {
    for (let i = 0; i < this[arrayName].length; i++) {
      this[checkBoxName][i] = false;
    }
  }

  getTerms() {
    this.spinner.show();
    this._api.functionGET('user/getUserPendingAgreements').subscribe((response) => {
      this.spinner.hide();
      const data = <any[]>response['data'];
      const allBusiness = Object.keys(data['agreement_unagreed_biz_list']);
      const availBusiness = allBusiness.filter((x) => data['agreement_unagreed_biz_list'][x].length > 0);
      const businessTerms = data['biz_accepted_list'].filter(x => availBusiness.includes(x.bt_agreement_id));
      businessTerms.map((x) => {
        data['agreement_unagreed_biz_list'][x.bt_agreement_id].map(row => row['checked'] = true);
        x['businessList'] = data['agreement_unagreed_biz_list'][x.bt_agreement_id];
        x['type'] = 'Business';
      });
      this.businessTerms = businessTerms;
      this.userTerms = data['usr_un_accepted_array'];
      this.userTerms.map((x) => { x['type'] = 'User'; });
      if (this.businessTerms.length + this.userTerms.length === 0) {
        this.login();
      }
      this.bindCheckBox('userTerms', 'userCheckmarks');
      this.bindCheckBox('businessTerms', 'businessCheckmarks');
      this.initTab();
    });
  }
  goFrwd() {
    if (this.selectedIndex_user === this.userTerms.length - 1 && this.tabvis === 0 && this.businessTerms.length > 0) {
      this.tabvis = 1;
      this.selectedIndex_business = 0;
      this._utilityService.addAttr(); 
      return;
    }
    if (this.tabvis === 1 && this.selectedIndex_business < this.businessTerms.length - 1) {
      this.selectedIndex_business++;
    } else if (this.tabvis === 0 && this.selectedIndex_user < this.userTerms.length - 1) {
      this.selectedIndex_user++;
    }
    this._utilityService.addAttr(); 
  }
  back() {
    if (this.selectedIndex_business === 0 && this.tabvis === 1) {
      this.tabvis = 0;
      this.selectedIndex_user = this.userTerms.length - 1;
      this._utilityService.addAttr(); 
      return;
    }
    if (this.tabvis === 1) {
      this.selectedIndex_business--;
    } else {
      this.selectedIndex_user--;
    }
    this._utilityService.addAttr(); 
  }
  validateAgreement(array: string) {
    let checked = true;
    Object.values(this[array]).map((x) => {
      if (!x) {
        checked = false;
        return;
      }
    });
    return checked;
  }
  save() {
    const validUser = this.validateAgreement('userCheckmarks');
    const validBusiness = this.validateAgreement('businessCheckmarks');
    if (validUser && validBusiness) {
      this.login();
    } else {
      this._api.openSnackBar('Please accept all Terms & Conditions', 'Error');
    }
  }
  get hasBackBtn() {
    if (this.tabvis === 0) {
      return this.selectedIndex_user !== 0;
    } else {
      return this.selectedIndex_business !== 0 || this.userTerms.length > 0;
    }
  }
  get hasNextBtn() {
    if (this.tabvis === 0) {
      return this.selectedIndex_user < this.userTerms.length - 1 || this.businessTerms.length !== 0;
    } else {
      return this.selectedIndex_business < this.businessTerms.length - 1;
    }
  }
  get hasSaveBtn() {
    if (this.tabvis === 0) {
      return this.selectedIndex_user >= this.userTerms.length - 1 && this.businessTerms.length === 0;
    } else {
      return this.selectedIndex_business >= this.businessTerms.length - 1;
    }
  }
  initTab() {
    if (this.userTerms.length > 0) {
      this.selectedIndex_user = 0;
      this.tabvis = 0;
      this._utilityService.addAttr(); 
      return;
    }
    if (this.businessTerms.length > 0) {
      this.selectedIndex_business = 0;
      this.tabvis = 1;
      this._utilityService.addAttr(); 
      return;
    }
  }
  login() {
    const businessAgreement = [];
    const userAgreement = [];
    this.temsCheckstats.map((x) => {
      if (x.type === 'Business') {
        const businessID = [];
        x['businessList'].map((y) => {
          if (y.checked) {
            businessID.push(y.bp_business_id);
          }
        });
        businessAgreement.push({
          bt_agreement_id: x.bt_agreement_id
          , agreed_biz_list: businessID
        });
      } else if (x.type === 'User') {
        userAgreement.push(x.bt_agreement_id);
      }
    });
    const apiObj = {
      user_agreements: userAgreement
      , business_agreements: businessAgreement
    };
    this._api.functionPOST('user/AddUserAgreements', apiObj).subscribe((res) => {
      if (res['success']) {
        if (!res['data']['token']) {
          this._api.openSnackBar(res['data']['Message'], 'Success');
          this.getTerms();
          return;
        }
        this.cookie.set('token', res['data']['token'], 0, '/',
        null,
        null, 'Lax');

        if (res['data']['code'] === 450) {
          if (this.action) {
            this.router.navigate(['/two_factor_authentication'], {queryParams: {'action': this.action}});
          } else {
            this.router.navigate(['/two_factor_authentication']);
          }
          return;
        }
        if (res['data']['agreementNotification']) {
          if (this.action) {
            this.router.navigate(['/terms-and-conditions'], {queryParams: {'action': this.action}});
          } else {
            this.router.navigate(['/terms-and-conditions']);
          }
          return;
        }
        // if (!res['data']['idme_pass']) {
        //   this.router.navigate(['/verification']);
        //   return;
        // }
        // if (res['data']['kyc_pending'] && res['data']['idme_pass']) {
        //   this.router.navigate(['/pending_approval']);
        //   return;
        // }
        //  if (res['data']['kyc_pending'] && res['data']['idme_pass']) {
        //   this.router.navigate(['/current_business']);
        //   return;
        // }

        if (res['data']['kyc_pending']) {
          this.router.navigate(['/current_business']);
          return;
        }
        
        if (res['data']['isRestrictedUser']) {
          this.router.navigate(['/current_business/profile']);
          return;
        }
        if (res['data']['no_allowedBusinesses'] === 0) {
          if (this.action === 'passwordReset') {
            this.router.navigate(['/current_business/Security_Settings']);
          } else {
            this.router.navigate(['/current_business']);
          }
          return;
        }
        if (!res['data']['kyc_pending'] &&
          // res['data']['idme_pass'] &&
          res['data']['no_allowedBusinesses'] !== 0) {
          // this.getExpiry();
          if (res['data']['expireNotification']) {
            localStorage.setItem('expiry', res['data']['expireNotification_message']);
          }
          if (this.action === 'passwordReset') {
            this.router.navigate(['/dashboard/Security_Settings']);
          } else {
            this.router.navigate(['/dashboard/task-management']);
          }
        }
      } else {
        this._api.logOut();
      }
    });
  }
  checkTerm($event, index, array: string, tabIndex: string) {
    if ($event.checked) {
      this.temsCheckstats.push({
        bt_agreement_id: this[array][index].bt_agreement_id
        , businessList: this[array][index].businessList
        , type: this[array][index].type
      });
      this.goFrwd();
    } else {
      this.temsCheckstats.map((x, i) => {
        if (x.bt_agreement_id === this[array][index].bt_agreement_id) {
          this.temsCheckstats.splice(i, 1);
        }
      });
    }
  }
  backToLogin() {
     this.router.navigate(['/']);
    this.cookie.deleteAll('/');
  }

}
